import { tss } from 'tss-react';

export const useStyles = tss.create({
	label: {
		border: '2px solid black',
		padding: '0px 5px',
		paddingBottom: '5px',
		backgroundColor: 'white',
	},
	title: {
		fontWeight: '900',
		fontSize: '2.2em',
		borderBottom: '1px solid black',
		marginTop: '-4px',
	},
	servingSize: {
		display: 'flex',
		justifyContent: 'space-between',
		fontWeight: '900',
		borderBottom: '10px solid black',
		marginTop: '0px',
	},
	amountPerServing: {
		fontWeight: '700',
	},
	caloriesContainer: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'end',
		marginTop: '-20px',
		borderBottom: '5px solid black',
	},
	calories: {
		fontSize: '1.8em',
		fontWeight: '800',
		marginBottom: '-5px',
	},
	caloriesAmount: {
		fontSize: '2.2em',
		fontWeight: '900',
		marginBottom: '-5px',
	},
	dailyValue: {
		fontSize: '0.85em',
		fontWeight: '900',
		textAlign: 'end',
		borderBottom: '1px solid black',
	},

	valuesCategory: {
		display: 'flex',
		justifyContent: 'space-between',
		fontSize: '0.85em',
		borderBottom: '1px solid black',
	},
	valuesDetail: {
		paddingLeft: '15px',
		fontSize: '0.85em',
		display: 'flex',
		justifyContent: 'space-between',
		borderBottom: '1px solid black',
	},
	valuesDetailDetail: {
		paddingLeft: '0px',
		marginLeft: '30px',
		borderTop: '1px solid black',
	},
	valuesBold: {
		fontWeight: '900',
	},
	valuesItalic: {
		fontStyle: 'italic',
	},
	footnote: {
		display: 'flex',
		gap: '2px',
		fontSize: '0.6em',
		letterSpacing: '-0.4px',
		lineHeight: '12px',
		marginTop: '4px',
	},
	sugar: {
		paddingLeft: '15px',
		fontSize: '0.85em',
		display: 'flex',
		justifyContent: 'space-between',
	},
	protein: {
		display: 'flex',
		justifyContent: 'space-between',
		fontSize: '0.85em',
		borderTop: '1px solid black',
		borderBottom: '10px solid black',
	},
	potassium: {
		display: 'flex',
		justifyContent: 'space-between',
		fontSize: '0.85em',
		borderBottom: '5px solid black',
	},
});
